import { useStore } from "@/store/AppStore";
import { PageHeader } from "@/components/kit";
import { FeedbackItem } from "@/components/Lists";
import { PROFILES } from "@/data/mock";

export default function CollabFeedback() {
  const { state } = useStore();
  const list = state.feedbacks.filter((f) => f.collaboratorId === PROFILES.colaboradora.collaboratorId);
  return (
    <div data-testid="collab-feedback-page">
      <PageHeader eyebrow="Seu desenvolvimento" title="Feedback recebido" subtitle="Mensagens da gestora e da consultoria sobre o seu trabalho." />
      <div className="grid max-w-4xl grid-cols-1 gap-4 md:grid-cols-2" data-testid="collab-feedback-list">
        {list.map((fb) => <FeedbackItem key={fb.id} fb={fb} />)}
        {!list.length && <p className="text-sm text-neutral-400">Nenhum feedback ainda.</p>}
      </div>
    </div>
  );
}
